import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Block from '../Block'
import StorageGroup from '../StorageGroup'
import { CalculatorContext } from '../Context/CalculatorContext'
import { STORAGE_GROUP_TITLE } from '../../strings/titles'
import { calculateStorageCost } from '../../model/calculator/storage'

const propTypes = {
    cost: PropTypes.shape({
        total: PropTypes.number.isRequired,
        sources: PropTypes.objectOf(PropTypes.number).isRequired,
        averageYearlyStorage: PropTypes.objectOf(PropTypes.number).isRequired
    }).isRequired,
    setCost: PropTypes.func.isRequired
}

type Props = PropTypes.InferProps<typeof propTypes>

const StorageBlock = ({ cost, setCost }: Props) => {
    const { currency } = useContext(CalculatorContext)

    const [storage, setStorage] = useState({
        highVelocity: {
            cap: 0,
            expectedGrowth: 0
        },
        highDensity: {
            cap: 0,
            expectedGrowth: 0
        },
        awsGlacier: {
            initialAmount: 0,
            expectedGrowth: 0
        },
        awsDeepGlacier: {
            initialAmount: 0,
            expectedGrowth: 0
        }
    })

    useEffect(() => {
        setCost(calculateStorageCost(storage))
    }, [storage, currency, setCost])

    return (
        <Block cost={cost.total} title={STORAGE_GROUP_TITLE} startOpen={false}>
            <StorageGroup
                storage={storage}
                setStorage={setStorage}
                averageYearlyStorage={cost.averageYearlyStorage}
            />
        </Block>
    )
}

StorageBlock.propTypes = propTypes

export default StorageBlock
